import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Message, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import SubscriptionTicket from '../../models/subscriptionTicket';
import { useNotifications, Notification } from '../../components/notifications/notificationsProvider';

export default function ResendTicketModal({ show, onClose, organizationId, subscriptionId, subscriptionLink, ticketIds }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const { addNotification } = useNotifications();
    const [isLoading, setIsLoading] = React.useState(false);

    const onResend = React.useCallback(() => {
        if (!subscriptionLink?.id && (!ticketIds || ticketIds.length === 0)) {
            toast.error(t('ticket.webservice.ticket-list.resend-modal.error'));
            return;
        }

        setIsLoading(true);

        SubscriptionTicket.resend_tickets({
            organizationId,
            subscriptionId,
            subscription_link_id: subscriptionLink?.id ?? null,
            ticket_ids: ticketIds ?? null
        })
            .then(response => {
                addNotification(new Notification('async_actions', 'resend_tickets', 'webservice', response?.response?.task_id));
                toast.info(t('ticket.webservice.ticket-list.resend-modal.success'));
            })
            .catch(error => {
                console.error('Error resending tickets:', error);
                toast.error(t('ticket.webservice.ticket-list.resend-modal.error'));
            })
            .finally(() => {
                setIsLoading(false);
                onClose();
            });
    }, [subscriptionLink, ticketIds, subscriptionId, organizationId, onClose, toast, t, addNotification]);

    return (
        <Modal
            open={show}
            onClose={onClose}
            title={t('ticket.webservice.ticket-list.resend-modal.title')}
            submitButton={
                <Button primary onClick={onResend} loading={isLoading}>
                    {t('ticket.common.action.confirm')}
                </Button>
            }
            cancelButton={
                <Button onClick={onClose} disabled={isLoading}>
                    {t('ticket.common.action.cancel')}
                </Button>
            }
        >
            <Message title={t('ticket.webservice.ticket-list.resend-modal.confirmation')} type="warning">
                {t('ticket.webservice.ticket-list.resend-modal.text')}
            </Message>
        </Modal>
    );
}

ResendTicketModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    organizationId: PropTypes.string.isRequired,
    subscriptionId: PropTypes.string.isRequired,
    subscriptionLink: PropTypes.object,
    ticketIds: PropTypes.array
};
